<template>
  <div class="change-price-wrapper">
    <div class="form-group">
      <select-bid-dropdown
        :lot-data="auctionStore.activeLot"
        :user-bid-prop="auctionStore.activeLot.current_bid"
        :current-bid-prop="auctionStore.activeLot.current_bid"
        :bids-count-prop="auctionStore.activeLot.bids_count"
        @update:selected-bid="onPriceChange"></select-bid-dropdown>
    </div>

    <div class="action-buttons">
      <button class="btn btn-blue" @click="save">{{ trans("live.modals.change_price.confirm_button") }}</button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { reactive } from "vue";
  import { trans } from "@/utils/trans";
  import { useToast } from "primevue/usetoast";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import apiClient from "@/services/api";
  import { isObject } from "lodash";
  import { SelectBidDropdown } from "@/components/_partials/lot-info-popup";

  const toast = useToast();
  const auctionStore = useAuctionStore();

  const state = reactive({
    changePriceAmount: 0
  });

  const onPriceChange = (nv) => {
    state.changePriceAmount = nv;
  };

  const save = () => {
    apiClient
      .post("/api/lots/" + auctionStore.activeLot.id + "/update-current-bid", {
        amount: state.changePriceAmount
      })
      .then((response) => {
        if (response.data.success) {
          toast.add({
            severity: "success",
            summary: trans("live.toast.success"),
            detail: trans("live.toast.lot.price_changed"),
            life: 6000
          });
          state.changePriceAmount = null;
        }
      })
      .catch((error) => {
        if (isObject(error.response.data?.errors)) {
          const errors = [] as string[];
          Object.values(error.response.data.errors).forEach((itemErrors) => {
            errors.push(...itemErrors);
          });

          errors.forEach((error: string) => {
            toast.add({
              severity: "error",
              summary: trans("live.toast.error"),
              detail: error || trans("live.toast.unknown_error"),
              life: 6000
            });
          });
        }
      });
  };
</script>
